import React from 'react'

import Chart from './Chart'
import useSize from './useSize'

const Wrapper = (props) => {
  const [ref, size] = useSize()
  return (
    <div ref={ref} style={{ height: '100%', overflow: 'hidden' }}>
      {size && <Chart width={size.width} height={size.height} {...props} />}
    </div>
  )
}

export default Wrapper
